import DateFnsUtils from "@date-io/date-fns";
import {
  Fab,
  Grid,
  Icon,
  MenuItem,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import { useEffect, useRef, useState } from "react";

import { getData } from "../../../api/apiCaller";
import Autocomplete from "../../../components/Autocomplete";
import AutocompletePhoneNumber from "../../../components/autocomplete/AutocompletePhoneNumber";
import { SWITCHBOARD_GROUPS } from "../../../constant";

// TODO fix bug scroll bottom run 2 times
const REPORT_TYPES = [
  { id: 1, name: "Bảng kê chi tiết cuộc gọi qua tổng đài" },
  {
    id: 2.1,
    name: "Bảng kê tổng hợp cước viễn thông tạm tính chi tiết theo đơn vị",
  },
  {
    id: 2.2,
    name: "Bảng kê tổng hợp cước viễn thông tạm tính từng Bưu điện tỉnh/Thành phố",
  },
  {
    id: 3,
    name: "Bảng kê tổng hợp cước viễn thông tạm tính theo số máy lẻ từng Bưu điện tỉnh/thành phố",
  },
];

const OPTIONS_SIZE = 20;

const SearchBar = ({ searchForm, onClickExport }) => {
  const [extensions, setExtensions] = useState([]);
  const extensionSearchKey = useRef(""); // key tìm kiếm
  const [cityPostOffices, setCityPostOffices] = useState([]);
  const cityPostOfficeSearchKey = useRef("");
  const [districtPostOffices, setDistrictPostOffices] = useState([]);
  const districtPostOfficesKey = useRef("");
  const [subOrgs, setSubOrgs] = useState([]);
  const subOrgSearchKey = useRef("");

  const getCityPostOffice = async (name, limit) => {
    const where = {
      ...(name && {
        or: [
          { name: { like: name, options: "i" } },
          { code: { like: name, options: "i" } },
        ],
      }),
    };
    // TODO constant
    const { data } = await getData("/vnpost/city-post-office", {
      filter: { where, limit },
    });
    setCityPostOffices(data);
  };

  const getDistrictPostOffice = async (name, limit, citycode) => {
    const where = {
      ...(citycode && { citycode }),
      ...(name && {
        or: [
          { name: { like: name, options: "i" } },
          { code: { like: name, options: "i" } },
        ],
      }),
    };
    const { data } = await getData("/vnpost/district-post-office", {
      filter: { where, limit },
    });
    setDistrictPostOffices(data);
  };

  const getSubOrgs = async (fullname, limit, citycode, districtcode) => {
    const where = {
      ...(fullname && { fullname: { like: fullname, options: "i" } }),
      ...(citycode && !districtcode && { citycode }),
      ...(districtcode && { districtcode }),
    };
    const { data } = await getData("/vnpost/province", {
      filter: { where, limit },
    });
    setSubOrgs(data);
  };

  // TODO xử lý duplicated code vs màn báo cáo cuộc gọi vào và cuộc gọi ra
  const getExtension = async (inputString, limit, city, district, subOrg) => {
    const name = inputString.includes("-")
      ? inputString.split("-")[0].trim()
      : inputString.trim();
    const username = inputString.includes("-")
      ? inputString.split("-")[1].trim()
      : inputString.trim();

    const where = {
      ...(name && {
        or: [{ name: { like: name } }, { username: { like: username } }],
      }),
      ...(city && !district && !subOrg && { city }),
      ...(district && !subOrg && { district }),
      ...(subOrg && { subOrg: { inq: [subOrg] } }),
    };

    const { data } = await getData("/cloud-pbx/extension", {
      filter: { where, limit },
    });
    setExtensions(data);
  };

  useEffect(() => {
    getCityPostOffice("", OPTIONS_SIZE);
    getDistrictPostOffice("", OPTIONS_SIZE);
    getSubOrgs("", OPTIONS_SIZE);
    getExtension("", OPTIONS_SIZE);
  }, []);

  const {
    reportType,
    timeType,
    unitType, // Đơn vị
  } = searchForm.values;

  return (
    <form onSubmit={searchForm.handleSubmit}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={24}>
          <Grid item xs={12} md={6}>
            <TextField
              {...searchForm.getFieldProps("reportType")}
              select
              label="Loại báo cáo"
              variant="outlined"
              fullWidth>
              {REPORT_TYPES.map((item) => (
                <MenuItem value={item.id}>{item.name}</MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              {...searchForm.getFieldProps("switchboardGroup")}
              onChange={(e) => {
                searchForm.setFieldValue("switchboardGroup", e.target.value);
                searchForm.setFieldValue("phoneNumbers", []);
              }}
              select
              label="Nhóm tổng đài"
              variant="outlined"
              fullWidth>
              {SWITCHBOARD_GROUPS.map((item) => (
                <MenuItem value={item.id}>{item.name}</MenuItem>
              ))}
            </TextField>
          </Grid>

          {(reportType === 1 || reportType === 2.1 || reportType === 2.2) && (
            <Grid item xs={12} md={3}>
              <AutocompletePhoneNumber
                label={reportType === 1 ? "Đầu số gọi ra" : "Đầu số"}
                value={searchForm.values?.phoneNumbers || []}
                onChange={(value) => {
                  searchForm.setFieldValue("phoneNumbers", value);
                }}
                switchboardGroup={searchForm.values.switchboardGroup}
              />
            </Grid>
          )}

          {reportType === 2.1 && (
            <Grid item xs={12} md={3}>
              <TextField
                {...searchForm.getFieldProps("unitType")}
                onChange={(e) => {
                  searchForm.setFieldValue("city", null);
                  searchForm.setFieldValue("district", null);
                  searchForm.setFieldValue("subOrg", null);
                  searchForm.setFieldValue("unitType", e.target.value);
                }}
                select
                label="Đơn vị"
                variant="outlined"
                fullWidth>
                <MenuItem value="city">Bưu điện tỉnh/thành phố</MenuItem>
                <MenuItem value="district">Bưu điện huyện</MenuItem>
                <MenuItem value="subOrg">Bưu cục</MenuItem>
              </TextField>
            </Grid>
          )}

          <Grid item xs={12} md={3}>
            <Autocomplete
              options={cityPostOffices}
              value={searchForm.values.city}
              onChangeValue={(option) => {
                searchForm.setFieldValue("city", option);
                searchForm.setFieldValue("district", null);
                searchForm.setFieldValue("subOrg", null);
                searchForm.setFieldValue("extension", null);
                getDistrictPostOffice("", OPTIONS_SIZE, option.code);
                getSubOrgs("", OPTIONS_SIZE, option.code);
                getExtension("", OPTIONS_SIZE, option.code);
                districtPostOfficesKey.current = "";
                subOrgSearchKey.current = "";
                extensionSearchKey.current = "";
              }}
              onTextChange={(text) => {
                cityPostOfficeSearchKey.current = text;
                getCityPostOffice(text, OPTIONS_SIZE);
              }}
              onClose={() => {
                cityPostOfficeSearchKey.current = "";
                getCityPostOffice("", OPTIONS_SIZE);
              }}
              getLabel={(option) =>
                `${option?.code ? option.code + " - " : ""}${
                  option?.name || ""
                }`
              }
              onScrollBottom={(text, currentLength) => {
                getCityPostOffice(
                  cityPostOfficeSearchKey.current,
                  currentLength + OPTIONS_SIZE
                );
              }}
              label="Bưu điện tỉnh/thành phố"
              debounceTime={300}
              InputLabelProps={{
                shrink: true,
              }}
              isVisibleAllOption
            />
          </Grid>

          {(reportType === 1 ||
            (reportType === 2.1 &&
              (unitType === "district" || unitType === "subOrg"))) && (
            <Grid item xs={12} md={3}>
              <Autocomplete
                options={districtPostOffices}
                value={searchForm.values.district}
                onChangeValue={(option) => {
                  searchForm.setFieldValue("district", option);
                  searchForm.setFieldValue("subOrg", null);
                  searchForm.setFieldValue("extension", null);
                  getSubOrgs(
                    "",
                    OPTIONS_SIZE,
                    searchForm.values.city?.code,
                    option?.code
                  );
                  getExtension(
                    "",
                    OPTIONS_SIZE,
                    searchForm.values.city?.code,
                    option?.code
                  );
                  subOrgSearchKey.current = "";
                  extensionSearchKey.current = "";
                }}
                onTextChange={(text) => {
                  districtPostOfficesKey.current = text;
                  getDistrictPostOffice(
                    text,
                    OPTIONS_SIZE,
                    searchForm.values.city?.code
                  );
                }}
                getLabel={(option) =>
                  `${option?.code ? option?.code + " - " : ""}${
                    option?.name || ""
                  }`
                }
                onScrollBottom={(text, currentLength) => {
                  getDistrictPostOffice(
                    districtPostOfficesKey.current,
                    currentLength + OPTIONS_SIZE,
                    searchForm.values.city?.code
                  );
                }}
                onClose={() => {
                  districtPostOfficesKey.current = "";
                  getDistrictPostOffice(
                    "",
                    OPTIONS_SIZE,
                    searchForm.values.city?.code
                  );
                }}
                label="Bưu điện huyện/Trung tâm CSKH"
                debounceTime={300}
                InputLabelProps={{
                  shrink: true,
                }}
                isVisibleAllOption
              />
            </Grid>
          )}

          {(reportType === 1 ||
            (reportType === 2.1 && unitType === "subOrg")) && (
            <Grid item xs={12} md={3}>
              <Autocomplete
                options={subOrgs}
                value={searchForm.values.subOrg}
                onChangeValue={(option) => {
                  searchForm.setFieldValue("subOrg", option);
                  searchForm.setFieldValue("extension", null);
                  getExtension(
                    "",
                    OPTIONS_SIZE,
                    searchForm.values.city?.code,
                    searchForm.values.district?.code,
                    option?.code
                  );
                  extensionSearchKey.current = "";
                }}
                onTextChange={(text) => {
                  subOrgSearchKey.current = text;
                  getSubOrgs(
                    text,
                    OPTIONS_SIZE,
                    searchForm.values.city?.code,
                    searchForm.values.district?.code
                  );
                }}
                getLabel={(option) => option?.name || ""}
                onScrollBottom={(text, currentLength) => {
                  getSubOrgs(
                    subOrgSearchKey.current,
                    currentLength + OPTIONS_SIZE,
                    searchForm.values.city?.code,
                    searchForm.values.district?.code
                  );
                }}
                onClose={() => {
                  subOrgSearchKey.current = "";
                  getSubOrgs(
                    "",
                    OPTIONS_SIZE,
                    searchForm.values.city?.code,
                    searchForm.values.district?.code
                  );
                }}
                label="Bưu cục"
                debounceTime={300}
                InputLabelProps={{
                  shrink: true,
                }}
                isVisibleAllOption
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <Grid container spacing={24}>
              {(reportType === 2.1 ||
                reportType === 2.2 ||
                reportType === 3) && (
                <Grid item xs={12} md={3}>
                  <TextField
                    {...searchForm.getFieldProps("timeType")}
                    select
                    label="Thời gian"
                    variant="outlined"
                    fullWidth>
                    <MenuItem value="byDate">Theo ngày</MenuItem>
                    <MenuItem value="byMonth">Theo tháng</MenuItem>
                  </TextField>
                </Grid>
              )}
              {(reportType === 1 ||
                ((reportType === 2.1 ||
                  reportType === 2.2 ||
                  reportType === 3) &&
                  timeType === "byDate")) && (
                <>
                  <Grid item xs={12} md={3}>
                    <InlineDatePicker
                      label="Từ ngày"
                      variant="outlined"
                      format="dd-MM-yyyy"
                      value={searchForm.values.startDate}
                      onChange={(date) =>
                        searchForm.setFieldValue("startDate", date)
                      }
                      maxDate={new Date()}
                      fullWidth
                      keyboard
                      invalidDateMessage="Định dạng Ngày không đúng"
                      maxDateMessage="Ngày lớn hơn ngày tối đa"
                      minDateMessage="Ngày nhỏ hơn ngày tối thiểu"
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <InlineDatePicker
                      label="Đến ngày"
                      variant="outlined"
                      value={searchForm.values.endDate}
                      onChange={(date) =>
                        searchForm.setFieldValue("endDate", date)
                      }
                      maxDate={new Date()}
                      minDate={searchForm.values.startDate}
                      format="dd-MM-yyyy"
                      fullWidth
                      keyboard
                      invalidDateMessage="Định dạng Ngày không đúng"
                      maxDateMessage="Ngày lớn hơn ngày tối đa"
                      minDateMessage="Ngày nhỏ hơn ngày tối thiểu"
                    />
                  </Grid>
                </>
              )}
              {(reportType === 2.1 || reportType === 2.2 || reportType === 3) &&
                timeType === "byMonth" && (
                  <Grid item xs={12} md={3}>
                    <InlineDatePicker
                      label="Chọn tháng"
                      variant="outlined"
                      maxDate={new Date()}
                      format="MM-yyyy"
                      value={searchForm.values.month}
                      views={["year", "month"]}
                      onChange={(date) =>
                        searchForm.setFieldValue("month", date)
                      }
                      validators={["required"]}
                      fullWidth
                      keyboard
                      invalidDateMessage="Định dạng tháng không đúng"
                      maxDateMessage="Tháng lớn hơn tháng tối đa"
                      minDateMessage="Tháng nhỏ hơn tháng tối thiểu"
                    />
                  </Grid>
                )}
              {(reportType === 1 || reportType === 3) && (
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    options={extensions}
                    value={searchForm.values.extension}
                    onChangeValue={(option) => {
                      searchForm.setFieldValue("extension", option);
                    }}
                    onTextChange={(text) => {
                      extensionSearchKey.current = text;
                      getExtension(
                        text,
                        OPTIONS_SIZE,
                        searchForm.values.city?.code,
                        searchForm.values.district?.code,
                        searchForm.values.subOrg?.code
                      );
                    }}
                    getLabel={(option) =>
                      option ? `${option?.name} - ${option?.username}` : ""
                    }
                    onScrollBottom={(text, currentLength) => {
                      getExtension(
                        extensionSearchKey.current,
                        currentLength + OPTIONS_SIZE,
                        searchForm.values.city?.code,
                        searchForm.values.district?.code,
                        searchForm.values.subOrg?.code
                      );
                    }}
                    label="Số máy lẻ gọi ra"
                    debounceTime={300}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onClose={() => {
                      extensionSearchKey.current = "";
                      getExtension(
                        "",
                        OPTIONS_SIZE,
                        searchForm.values.city?.code,
                        searchForm.values.district?.code,
                        searchForm.values.subOrg?.code
                      );
                    }}
                    isVisibleAllOption
                  />
                </Grid>
              )}

              <Grid
                item
                xs={12}
                md={3}
                style={{ display: "flex", alignItems: "center" }}>
                <Tooltip title="Tìm kiếm" disableFocusListener>
                  <Fab
                    color="primary"
                    style={{ marginLeft: "15px" }}
                    type="submit">
                    <Search />
                  </Fab>
                </Tooltip>
                <Tooltip title="Tải báo cáo" disableFocusListener>
                  <Fab
                    color="primary"
                    style={{ marginLeft: "15px" }}
                    onClick={onClickExport}>
                    <Icon>save_alt</Icon>
                  </Fab>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </form>
  );
};

export default SearchBar;
